module.exports = __webpack_public_path__ + "1fe8122e0a6813aafd19813d6426f2a7.woff2";


//////////////////
// WEBPACK FOOTER
// ./static/EuclidCircularA-Medium-WebXL.woff2
// module id = 216
// module chunks = 0